import styles from "./addtaskform.module.css";
import { Button, TextField } from "@mui/material";
import { useState } from "react";
import { Trash2 } from "react-feather";

const TaskListCard = ({ item, index, index2, setTaskList, editTaskOpen, setActiveTaskId, setAddTaskOpen }) => {
  const [taskError, setTaskError] = useState(false);
  const [taskVal, setTaskVal] = useState(item);

  const addTask = () => {
    if (taskVal !== "") {
      setActiveTaskId(null);
      setTaskList((prev) => {
        return prev?.map((itt, inn) => {
          if (inn === index) return taskVal;
          return itt;
        });
      });
    } else {
      setTaskError(true);
    }
  };

  return (
    <>
      {!editTaskOpen && (
        <div
          className={`${styles.TasksNameList}`}
          onClick={(e) => {
            setActiveTaskId(index2);
            setAddTaskOpen(false);
          }}
        >
          <p className={`${styles.TaskListName}`}>
            {index2 + 1}. {item}
          </p>
          <button
            className={`${styles.DeleteBU}`}
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setTaskList((prev) => prev.filter((_, i) => i !== index));
            }}
          >
            <Trash2 />
          </button>
        </div>
      )}
      {editTaskOpen && (
        <div className={`${styles.EditList}`}>
          <div className={`${styles.HalfSecFull} FormGroup`}>
            <TextField
              id="outlined-basic"
              label="Edit Task"
              variant="outlined"
              value={taskVal}
              onChange={(e) => {
                setTaskError(false);
                setTaskVal(e?.target?.value);
              }}
            />
            {taskError && (
              <p className={`${styles.ErrorM}`}>This field is required</p>
            )}
          </div>
          <div className={`${styles.ChecklistButtonAction}`}>
            <Button
              className={`${styles.AddChecklistBU}`}
              onClick={(e) => addTask()}
            >
              Save
            </Button>
            <Button
              className={`${styles.CancelChecklistBU}`}
              onClick={(e) => setActiveTaskId(null)}
            >
              Cancel
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default TaskListCard;
